import williamPortrait from "@/assets/william-portrait.webp";

const OperatorMandate = () => {
  return (
    <section className="operator-mandate-section">
      <div className="operator-mandate-container">
        <div className="operator-mandate-label">
          [ 1:1 ACCOUNTABILITY ]
        </div>

        <div className="operator-layout">
          <img
            src={williamPortrait}
            alt="William Palmer — Structural Web Architect"
            className="operator-portrait"
            loading="lazy"
            width={320}
            height={400}
          />

          <div className="operator-mandate-content">
            <p className="text-foreground font-bold">
              Most digital friction isn't an accident. It's a business model.
            </p>
            <p>
              The standard agency model relies on junior teams executing 40-word briefs. The DIY builder model relies on offloading the burden of architecture onto you. Both models are designed to facilitate lock-in and ongoing retainers, rather than operational performance.
            </p>
            <p className="text-foreground font-bold">
              They build dependencies. I build assets.
            </p>
            <p>
              When we engage, there is no B-team. You get a senior architect whose hands are on the keyboard, building high-leverage infrastructure that you actually own.
            </p>

            <div className="border-t border-border pt-8 mt-2">
              <span className="block font-mono text-xs font-bold text-primary tracking-[0.15em] uppercase mb-6">
                [ VERIFIED DEPLOYMENT ]
              </span>
              <p className="text-lg lg:text-xl text-foreground leading-relaxed normal-case mb-2 font-normal">
                We spent two years fighting our website. William came in, ripped out the friction, and built a system that actually scales.
              </p>
              <p className="font-mono text-sm text-muted-foreground normal-case mt-4">
                — Mo Rahman, Operations Manager, Cresco
              </p>
            </div>

            <div className="operator-signature border-t border-border pt-12">
              <p className="font-bold text-lg normal-case text-foreground mb-1">WILLIAM PALMER</p>
              <span className="operator-title">Structural Web Architect</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OperatorMandate;
